var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStrokeAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.757324,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#FD9C43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1575 13.2069L11.5143 9.64437L12.8588 13.2069H10.1575ZM17.231 16.8626L13.0638 5.82022C13.0589 5.80745 13.0539 5.79468 13.0488 5.78204C12.7926 5.15937 12.1925 4.75732 11.5193 4.75732H11.5176C10.8437 4.75794 10.2436 5.16141 9.98855 5.7851C9.9842 5.79563 9.98005 5.80616 9.97598 5.81669L5.77051 16.8587C5.49533 17.5812 5.85803 18.39 6.58051 18.6652C7.30306 18.9404 8.11191 18.5777 8.3871 17.8552L9.0911 16.0068H13.9154L14.6115 17.8512C14.823 18.4119 15.3557 18.7573 15.9214 18.7573C16.0857 18.7573 16.2528 18.7281 16.4155 18.6668C17.1389 18.3937 17.5041 17.586 17.231 16.8626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrokeAnswer);
export default __webpack_public_path__ + "static/media/icon-stroke-answer.d5c398a2a662d70ef7d97376fe7f8067.svg";
export { ForwardRef as ReactComponent };